const CLEAR_TOKEN = 'CLEAR_TOKEN';
const SET_TOKEN = 'SET_TOKEN';

const SET_USERINFO = 'SET_USER_INFO';
const CLEAR_LOGININFO = 'CLEAR_LOGININFO';

const SET_DICTIONARIES = 'SET_DICTIONARIES';
const SET_DEPARTS = 'SET_DEPARTS';
const SET_ALLDEPARTS = 'SET_ALLDEPARTS';
const SET_SUPGROUPS = 'SET_SUPGROUPS';
const SET_ALLSUPGROUPS = 'SET_ALLSUPGROUPS';
const SET_CATEGORIES = 'SET_CATEGORIES';
const SET_ALLCATEGORIES = 'SET_ALLCATEGORIES';
const SET_CLASSIFICATIONS = 'SET_CLASSIFICATIONS';
const SET_USERS = 'SET_USERS';
const SET_ALLUSERS = 'SET_ALLUSERS';

const SET_ROUTERS = 'SET_ROUTERS';
const SET_ROLEIDS = 'SET_ROLEIDS';

const WORK_PAGE_REMOVE = 'WORK_PAGE_REMOVE';
const WORK_PAGE_ROUTE = 'WORK_PAGE_ROUTE';
const WORK_PAGE_CLEAR_ALL = 'WORK_PAGE_CLEAR_ALL';
const REMOVE_CACHED_VIEW = 'REMOVE_CACHED_VIEW';
const ADD_CACHED_VIEW = 'ADD_CACHED_VIEW';
const DEL_OTHER_CACHED_VIEW = 'DEL_OTHER_CACHED_VIEW';
const REMOVE_ALL_CACHED_VIEW = 'REMOVE_ALL_CACHED_VIEW';
const DEL_LEFT_CACHED_VIEW = 'DEL_LEFT_CACHED_VIEW';
const DEL_RIGHT_CACHED_VIEW = 'DEL_RIGHT_CACHED_VIEW';
const DEL_OTHER_WORK_PAGE = 'DEL_OTHER_WORK_PAGE';
const DEL_LEFT_WORK_PAGE = 'DEL_LEFT_WORK_PAGE';
const DEL_RIGHT_WORK_PAGE = 'DEL_RIGHT_WORK_PAGE';
const SET_SIZE = 'SET_SIZE';
const SET_BREADCRUMB = 'SET_BREADCRUMB';
const SET_SYS_CONFIG = 'SET_SYS_CONFIG';
const SET_BUSINESS_CONFIG = 'SET_BUSINESS_CONFIG';

export default {
  SET_TOKEN,
  CLEAR_TOKEN,
  SET_USERINFO,
  CLEAR_LOGININFO,
  SET_DICTIONARIES,
  SET_DEPARTS,
  SET_ALLDEPARTS,
  SET_SUPGROUPS,
  SET_ALLSUPGROUPS,
  SET_CATEGORIES,
  SET_ALLCATEGORIES,
  SET_CLASSIFICATIONS,
  SET_USERS,
  SET_ALLUSERS,
  SET_ROUTERS,
  SET_ROLEIDS,
  WORK_PAGE_REMOVE,
  WORK_PAGE_ROUTE,
  WORK_PAGE_CLEAR_ALL,
  REMOVE_CACHED_VIEW,
  ADD_CACHED_VIEW,
  DEL_OTHER_CACHED_VIEW,
  REMOVE_ALL_CACHED_VIEW,
  DEL_LEFT_CACHED_VIEW,
  DEL_RIGHT_CACHED_VIEW,
  DEL_OTHER_WORK_PAGE,
  DEL_LEFT_WORK_PAGE,
  DEL_RIGHT_WORK_PAGE,
  SET_SIZE,
  SET_BREADCRUMB,
  SET_SYS_CONFIG,
  SET_BUSINESS_CONFIG
}


// WEBPACK FOOTER //
// ./src/store/types.js